import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@mui/material'
import { PUBLIC_URL } from '../../config/settings/environment'
import { Typography } from '@chilecompra/react-kit'
import { ContainerCard as Card, NotFoundImg } from './BehaviorSection.styles'

/**
 * The Empty Card Message component.
 * Displays the empty card message.
 */
const EmptyCardMessage = ({ onlyTextAndImage = false }) => {
  if (onlyTextAndImage) {
    return (
      <Box
        display="flex"
        gap="10px"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        width="25%"
        margin="0 auto"
        height="100%"
      >
        <NotFoundImg alt="No se encontraron resultados" margin="0" src={`${PUBLIC_URL}/assets/images/notFound.svg`} />
        <Typography fontWeight="bold" variant="body1">
          No existe información
        </Typography>
        <Typography variant="subtitle">El organismo comprador no cuenta con información para mostrar.</Typography>
      </Box>
    )
  }
  return (
    <Card
      display="flex"
      color="blank"
      enableBorder
      margin="42px 0 32px 0"
      alignItems="center"
      justifyContent="center"
      padding="80px 0"
    >
      <Box
        display="flex"
        gap="10px"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        width="25%"
        margin="0 auto"
      >
        <NotFoundImg alt="No se encontraron resultados" margin="0" src={`${PUBLIC_URL}/assets/images/notFound.svg`} />
        <Typography fontWeight="bold" variant="body1">
          No existe información
        </Typography>
        <Typography variant="subtitle">El organismo comprador no cuenta con información para mostrar.</Typography>
      </Box>
    </Card>
  )
}

EmptyCardMessage.propTypes = {
  onlyTextAndImage: PropTypes.bool
}

EmptyCardMessage.defaultProps = {
  onlyTextAndImage: false
}

export default EmptyCardMessage
